const POST_AUTH_REDIRECT_KEY = "lavado_post_auth_redirect";

function isSafeInternalPath(path: string) {
  return path.startsWith("/") && !path.startsWith("//");
}

export function savePostAuthRedirect(path: string) {
  if (isSafeInternalPath(path)) {
    sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, path);
  }
}

export function consumePostAuthRedirect() {
  const path = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);

  return path && isSafeInternalPath(path) ? path : null;
}
